// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import { type IInvestmentCashHoldingDetailsDto, IInvestmentCashHoldingDetailsDtoFromJSONTyped, IInvestmentCashHoldingDetailsDtoToJSON, IInvestmentCashHoldingDetailsDtoToJSONTyped } from './IInvestmentCashHoldingDetailsDto';
import { type IInvestmentFundHoldingDetailsDto, IInvestmentFundHoldingDetailsDtoFromJSONTyped, IInvestmentFundHoldingDetailsDtoToJSON, IInvestmentFundHoldingDetailsDtoToJSONTyped } from './IInvestmentFundHoldingDetailsDto';
/**
 * 
 * @export
 * @interface IInvestmentHoldingDetailsDto
 */
export interface IInvestmentHoldingDetailsDto {
    /**
     * 
     * @type {string}
     * @memberof IInvestmentHoldingDetailsDto
     */
    symbol?: string;
    /**
     * 
     * @type {number}
     * @memberof IInvestmentHoldingDetailsDto
     */
    election?: number;
    /**
     * 
     * @type {number}
     * @memberof IInvestmentHoldingDetailsDto
     */
    amount?: number;
    /**
     * 
     * @type {string}
     * @memberof IInvestmentHoldingDetailsDto
     */
    fund_name?: string;
    /**
     * 
     * @type {string}
     * @memberof IInvestmentHoldingDetailsDto
     */
    type: string;
}

/**
 * Check if a given object implements the IInvestmentHoldingDetailsDto interface.
 */
export function instanceOfIInvestmentHoldingDetailsDto(value: object): value is IInvestmentHoldingDetailsDto {
    if (!('type' in value) || value['type'] === undefined) return false;
    return true;
}

export function IInvestmentHoldingDetailsDtoFromJSON(json: any): IInvestmentHoldingDetailsDto {
    return IInvestmentHoldingDetailsDtoFromJSONTyped(json, false);
}

export function IInvestmentHoldingDetailsDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IInvestmentHoldingDetailsDto {
    if (json == null) {
        return json;
    }
    if (!ignoreDiscriminator) {
        if (json['@type'] === 'CASH') {
            return IInvestmentCashHoldingDetailsDtoFromJSONTyped(json, ignoreDiscriminator);
        }
        if (json['@type'] === 'FUND') {
            return IInvestmentFundHoldingDetailsDtoFromJSONTyped(json, ignoreDiscriminator);
        }
    }
    return {
        
        'symbol': json['symbol'] == null ? undefined : json['symbol'],
        'election': json['election'] == null ? undefined : json['election'],
        'amount': json['amount'] == null ? undefined : json['amount'],
        'fund_name': json['fund_name'] == null ? undefined : json['fund_name'],
        'type': json['@type'],
    };
}

export function IInvestmentHoldingDetailsDtoToJSON(json: any): IInvestmentHoldingDetailsDto {
    return IInvestmentHoldingDetailsDtoToJSONTyped(json, false);
}

export function IInvestmentHoldingDetailsDtoToJSONTyped(value?: IInvestmentHoldingDetailsDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    if (!ignoreDiscriminator) {
        switch (value['type']) {
            case 'CASH':
                return IInvestmentCashHoldingDetailsDtoToJSONTyped(value as IInvestmentCashHoldingDetailsDto, ignoreDiscriminator);
            case 'FUND':
                return IInvestmentFundHoldingDetailsDtoToJSONTyped(value as IInvestmentFundHoldingDetailsDto, ignoreDiscriminator);
            default:
                return value;
        }
    }

    return {
        
        'symbol': value['symbol'],
        'election': value['election'],
        'amount': value['amount'],
        'fund_name': value['fund_name'],
        '@type': value['type'],
    };
}

